// @flow

import React, { Component, Fragment } from 'react'
import { message } from 'antd'
import { containerIds } from 'modules/ui'
import renderUIError from 'helper/renderUIError'

type Props = {
  ui: {
    errors: [],
  },
  actions: {
    setUIState: Function,
  },
  ui: {},
  onChange: Function,
  onChangeCheck: Function,
  rowIndex: number,
  config: any,
  id: string,
  title: string,
  description: string,
  isRequired: boolean,
  isVisible: boolean,
  example: string,
  companyId: string,
}

export default class CompanyQuestion extends Component<Props> {
  render() {
    const {
      rowIndex,
      isVisible,
      onChangeRadio,
      onChangeCheckbox,
      ui,
    } = this.props

    const errors = (ui.errors || []).filter(e => rowIndex == e.index)
    return (
      <div className="business-reservation-setting__item">
        <div className="business-reservation-setting__visible">
          <div className="business-reservation-setting__switch-visible">
            <p className="business-reservation-setting__switch-visible__item">
              <input
                type="radio"
                value=""
                id={`request-radio__${rowIndex}-01`}
                name={`request-radio${rowIndex}`}
                defaultChecked={isVisible}
                onChange={e => onChangeRadio(e, rowIndex, true)}
              />
              <label
                htmlFor={`request-radio__${rowIndex}-01`}
                className="service-radio"
              >
                <span className="request-payment__name">表示</span>
              </label>
            </p>
            <p className="business-reservation-setting__switch-visible__item">
              <input
                type="radio"
                value=""
                id={`request-radio__${rowIndex}-02`}
                name={`request-radio${rowIndex}`}
                defaultChecked={!isVisible}
                onChange={e => onChangeRadio(e, rowIndex, false)}
              />
              <label
                htmlFor={`request-radio__${rowIndex}-02`}
                className="service-radio"
              >
                <span className="request-payment__name">非表示</span>
              </label>
            </p>
          </div>
          <div className="business-reservation-setting__require-visible">
            <div className="business-checkbox-wrap">
              <label
                className="business-checkbox"
                htmlFor={`checkbox-${rowIndex}`}
              >
                <input
                  type="checkbox"
                  id={`checkbox-${rowIndex}`}
                  className="business-checkbox__input"
                  checked={this.props.isRequired}
                  onChange={e => onChangeCheckbox(e, rowIndex)}
                />
                <span className="business-checkbox__label">必須入力</span>
              </label>
            </div>
          </div>
        </div>
        <ul>
          <li className="business-reservation-setting__line">
            <p className="business-reservation-setting__heading">
              <span className="icon-form icon-form__required">必須</span>
              タイトル
            </p>
            <input
              type="text"
              name="title"
              className={`business-reservation-setting__form business__form ${
                renderUIError.hasError('title', errors) ? 'form-error' : ''
              }`}
              value={this.props.title}
              onChange={e => this.props.onChange(e, rowIndex)}
              placeholder="例 : 部署名"
            />
            {renderUIError.settingError('title', errors)}
          </li>
          <li className="business-reservation-setting__line">
            <p className="business-reservation-setting__heading">
              <span className="icon-form icon-form__optional">任意</span>説明文
            </p>
            <textarea
              name="description"
              onChange={e => this.props.onChange(e, rowIndex)}
              className="business-reservation-setting__textarea"
              placeholder="例 : 部署名を入力してください。"
              defaultValue={this.props.description}
            />
          </li>
          <li className="business-reservation-setting__line">
            <p className="business-reservation-setting__heading">
              <span className="icon-form icon-form__required">必須</span>入力例
            </p>
            <textarea
              className={`business-reservation-setting__textarea ${
                renderUIError.hasError('example', errors) ? 'form-error' : ''
              }`}
              name="example"
              placeholder="例 : プロダクト開発部"
              onChange={e => this.props.onChange(e, rowIndex)}
              defaultValue={this.props.example}
            />
            {renderUIError.settingError('example', errors)}
          </li>
        </ul>
      </div>
    )
  }
}
